import { render, staticRenderFns } from "./NewEditClientView.vue?vue&type=template&id=9ee6fd1e&scoped=true"
import script from "./NewEditClientView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewEditClientView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewEditClientView.vue?vue&type=style&index=0&id=9ee6fd1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee6fd1e",
  null
  
)

export default component.exports